// extracted by mini-css-extract-plugin
module.exports = {"area":"DateInput_area__1gBKw","label":"DateInput_label__1dJVi","input":"DateInput_input__25Eej"};